import React, { Fragment } from 'react';

const NativeAppFeatureListCamps = () => {
  return (
    <Fragment>
      <li>
        Share your camper&apos;s matched photo stream with family and friends.
      </li>
      <li>Post &amp; download your favorite pics in hi-res.</li>
      <li>Send a Waldogram to your camper.</li>
      <li>Order prints delivered directly to your home.</li>
    </Fragment>
  );
};

export default NativeAppFeatureListCamps;
